/* eslint-disable */
export default {
  namespaced: true,
  state: {
    userVideoRequest: {
      enableVideo: false,
      enableAudio: false,
      blurVideo: true,
      enableTranscription: false,
    },
    tableSettings: null,
    lastQuickReply: null,
  },
  getters: {
    userVideoRequestPersisted: (state) => state.userVideoRequest,
    getTableSettings: (state) => (tableName) => {
      if (state.tableSettings && state.tableSettings[tableName]) {
        return state.tableSettings[tableName];
      }
      return null;
    },
    lastQuickReply: (state) => {
      if (state.lastQuickReply) {
        return state.lastQuickReply;
      }
      return {};
    }
  },
  mutations: {
    setUserVideoRequestPersisted(state, value) {
      state.userVideoRequest = value;
    },
    setLastQuickReply(state, data) {
      const { templateId, agencyId } = data;
      if (!state.lastQuickReply) {
        const quickReply = {};
        quickReply[agencyId] = templateId;
        state.lastQuickReply = {...quickReply};
      } else {
        const quickReply = {...state.lastQuickReply};
        quickReply[agencyId] = templateId;
        state.lastQuickReply = {...quickReply};
      }
    },
    clearTableSettings(state) {
      state.tableSettings = null;
    },
    updateTableSettings(state, data) {
      const { tableName, settings } = data;
      state.tableSettings = {
        ...state.tableSettings,
        [tableName]: { ...settings }
      };
    }
  },
};
